module.exports = __webpack_public_path__ + "static/media/image.471a57b1.png";